<template>
  <div class="rules-container" @click.stop>
    <div class="title">{{ title }}评分规则</div>
    <div class="content">
      <div class="c-item" v-for="(item, index) in data" :key="index">
        <div class="title-item" v-if="item.title">{{ item.title }}</div>
        <div class="type-list">
          <div
            class="type-item"
            v-for="(item1, index1) in item.list"
            :key="index1"
          >
            <div class="type-title" :class="[item1.type]" v-if="item1.title">
              {{ item1.title }}
            </div>
            <div class="desc" v-if="item1.desc">{{ item1.desc }}</div>
            <div class="text-list" v-if="item1.data.length">
              <div
                class="text-item"
                v-for="(item2, index2) in item1.data"
                :key="index2"
              >
                {{ item2 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="close-btn" @click="bindClose">关闭</div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClose() {
      this.$emit('input')
    }
  }
}
</script>
<style lang="scss" scoped>
.rules-container {
  position: relative;
  width: 100%;
  background-color: #fff;
  height: 100%;
  overflow-y: scroll;
  .title {
    background-color: #fff;
    text-align: center;
    position: sticky;
    width: 100%;
    top: 0;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    padding: 30px 0px 20px;
    line-height: 25px;
  }
  .content {
    width: 100%;
    box-sizing: border-box;
    padding: 0px 20px 60px;
    .title-item {
      height: 27px;
      background: #f7f7f7;
      border-radius: 6px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 27px;
      padding: 0px 20px;
      margin-bottom: 9px;
    }
    .type-list {
      padding-left: 20px;
      margin-bottom: 20px;
      .type-item {
        margin-bottom: 14px;
        .type-title {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 22px;
        }
        .green {
          color: rgba(60, 172, 147, 1);
        }
        .yellow {
          color: rgba(247, 181, 0, 1);
        }
        .red {
          color: rgba(240, 70, 70, 1);
        }
        .desc {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 22px;
        }
        .text-list {
          margin-top: 7px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.5);
          line-height: 22px;
          margin-bottom: 17px;
        }
      }
    }
  }
  .close-btn {
    width: 335px;
    height: 36px;
    line-height: 36px;
    background: #6236ff;
    border-radius: 8px;
    position: fixed;
    left: 50%;
    bottom: 28px;
    transform: translate(-50%, 0%);
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 36px;
  }
}
</style>
